import React, { useContext } from "react";
import DeviceHealthChart from "./DeviceHealthChart";
import { gql, useQuery } from "@apollo/client";
import StarekContext from "../context/StarekContext";
import moment from "moment";

function DeviceHealthMonitor({ devices }) {
    const inactivityTimeout = 5 * 60; // 5 minutes
    const unresponsiveTimeout = 60 * 60; // 60 minutes
    const minPowerLevel = 95; // 95%
    const buildLabels = (devices) => {
        // If no devices, return early with message
        if (!devices || devices.length === 0) {
            return (
                <div className="text-center">
                    <p className="text-muted mb-0">
                        There are no associated devices with this plant.{" "}
                        <a href="/devices" className="text-primary">
                            Start by adding devices
                        </a>
                    </p>
                </div>
            );
        }

        let ok = 0;
        let inactive = 0;
        let unresponsive = 0;
        let lowBattery = 0;

        devices.forEach((device) => {
            const lastHeartbeat = device?.device?.lastSeen?.master || 0;
            console.log(
                "Last Heartbeat for device",
                device.id,
                moment(lastHeartbeat).toISOString()
            );
            const minutesAgo = moment().diff(moment(lastHeartbeat), "seconds");

            if (
                minutesAgo >= inactivityTimeout &&
                minutesAgo < unresponsiveTimeout
            ) {
                inactive++;
            }
            if (minutesAgo >= unresponsiveTimeout) {
                unresponsive++;
            }

            // Check battery level
            const batteryLevel =
                device?.device?.runtime?.attributes?.battery_level;
            if (batteryLevel && batteryLevel < minPowerLevel) {
                lowBattery++;
            }
        });

        ok = devices.length - (inactive + unresponsive);

        // title: "One", value: 10, color: "#E38627"
        const chartData = [
            { title: "OK", value: ok, color: "var(--success)" },
            { title: "Inactive", value: inactive, color: "var(--warning)" },
            {
                title: "Attention",
                value: unresponsive,
                color: "var(--danger)",
            },
        ];
        return (
            <>
                <div className="text-center mb-4">
                    {ok > 0 && (
                        <div className="badge badge-success mr-1"> {ok} OK</div>
                    )}
                    {inactive > 0 && (
                        <div className="badge badge-warning mr-1 text-dark">
                            {" "}
                            {inactive} Inactive
                        </div>
                    )}
                    {unresponsive > 0 && (
                        <div className="badge badge-danger mr-1">
                            {" "}
                            {unresponsive} Unresponsive
                        </div>
                    )}
                </div>
                <DeviceHealthChart device={devices} chartData={chartData} />
                <br />
                <div className="text-center mb-4">
                    {lowBattery > 0 && (
                        <div className="badge bg-warning text-dark">
                            <i className="fas fa-battery-quarter mr-1" />
                            {lowBattery} Report Power Issues
                        </div>
                    )}
                </div>
            </>
        );
    };

    return (
        <div className="card" style={{ height: "400px" }}>
            <div
                className="card-header ui-sortable-handle d-flex justify-content-between align-items-center"
                style={{ cursor: "move" }}
            >
                <h3 className="card-title">
                    <i className="fas fa-clipboard mr-1" />
                    Devices
                </h3>
                <div className="card-tools ml-auto">
                    <ul className="nav nav-pills ml-auto">
                        <li className="nav-item">
                            <a className="nav-link active" href="/devices">
                                Manage Devices
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="card-body">
                <div className="row no-gutters align-items-center">
                    <div className="col-12 mr-2">{buildLabels(devices)}</div>
                </div>
            </div>
        </div>
    );
}

export default DeviceHealthMonitor;
